module.exports = __webpack_public_path__ + "img/cart.42658d20.svg";